// extracted by mini-css-extract-plugin
export default {"linkIcon":"PopupLink-linkIcon","linkText":"PopupLink-linkText"};